import { motion } from "framer-motion";
import { CalendarCheck, ShieldCheck } from "lucide-react";
import { MtgLogo } from "@/components/MtgLogo";
import { useSettings } from "@/context/SettingsContext";
import ReceptionistChat from "@/components/ReceptionistChat";

const FADE_INITIAL = { opacity: 0, y: 16 };
const FADE_ANIMATE = { opacity: 1, y: 0 };
const FADE_T1 = { duration: 0.5 };
const FADE_T2 = { duration: 0.5, delay: 0.1 };

export default function BookPublic() {
  const { settings } = useSettings();
  const brand = settings.brand_primary || "#0D9488";
  return (
    <div className="min-h-screen bg-slate-900">
      <div className="mx-auto flex min-h-screen max-w-5xl flex-col px-4 py-6 sm:px-5 sm:py-8">
        <div className="flex items-center justify-between">
          <MtgLogo withText name={settings.business_name} logoUrl={settings.logo_url} tagline={settings.tagline} />
          <div className="hidden items-center gap-2 text-xs text-slate-400 sm:flex">
            <ShieldCheck className="h-4 w-4" style={{ color: brand }} /> Secure booking
          </div>
        </div>

        <div className="grid flex-1 items-center gap-8 py-8 lg:grid-cols-2">
          <motion.div initial={FADE_INITIAL} animate={FADE_ANIMATE} transition={FADE_T1}>
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-semibold" style={{ color: brand }}>
              <CalendarCheck className="h-3.5 w-3.5" /> AI Booking Assistant
            </div>
            <h1 className="mt-4 font-heading text-4xl font-extrabold leading-tight text-white sm:text-5xl">
              Book your appointment with {settings.business_name}
            </h1>
            <p className="mt-4 max-w-md text-slate-300">
              Chat with our assistant to find a time that suits you — it checks live availability and books you straight in. No phone call needed.
            </p>
          </motion.div>

          <motion.div initial={FADE_INITIAL} animate={FADE_ANIMATE} transition={FADE_T2} className="h-[72vh] min-h-[460px] lg:h-[560px]">
            <ReceptionistChat channel="public" greeting={`Hi! Welcome to ${settings.business_name}. Are you a new patient or an existing/returning patient?`} initialOptions={[{ id: "new", name: "New patient" }, { id: "existing", name: "Existing / returning patient" }]} />
          </motion.div>
        </div>

        <div className="space-y-2 pb-2 text-center">
          <p className="mx-auto max-w-2xl text-[11px] leading-relaxed text-slate-500" data-testid="book-privacy-notice">
            Privacy: we use the details you provide only to arrange your appointment. This assistant books new
            appointments and checks availability — it cannot access or change your existing records. Chat
            transcripts are stored securely for up to 30 days. Your information is processed in line with UK GDPR.
          </p>
          <div className="font-mono text-[11px] text-slate-600">{settings.business_name} · Powered by AI reception</div>
        </div>
      </div>
    </div>
  );
}
